import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { styled } from '../styled';
export var AccordionDetailsComponentName = 'QuantumAcccordionDetails';
export var AccordionDetails = styled(MuiAccordionDetails, {
    name: AccordionDetailsComponentName,
    slot: 'Root',
})(function (_a) {
    var theme = _a.theme;
    return {
        display: 'grid',
        gridTemplateColumns: '40% repeat(4, 15%)',
        padding: "0px ".concat(theme.spacing(2)),
        borderBottom: "1px solid ".concat(theme.tokens.color_border_default),
        height: theme.typography.pxToRem(72),
    };
});
